<script setup lang="ts">
import { provide } from "vue"
/** label 116px / value right, mono, wraps instead of truncating. Full words only. */
withDefaults(defineProps<{ label?: string; value?: string }>(), { label: "—", value: undefined })
/* A status word inside the value wraps with it instead of running past the card's edge; tables keep
   their one-line cells (W9-PORTAL-UX: memory rows on the playground and deployment panes). */
provide("param-row", true)
</script>

<template>
  <div class="grid grid-cols-[var(--param-label-width)_minmax(0,1fr)] items-baseline gap-2 text-xs">
    <!-- A label with no space in it (a file path) breaks inside its column instead of running under the value. -->
    <span class="min-w-0 break-words text-muted-foreground">{{ label }}</span>
    <span class="num flex justify-end text-right text-[length:var(--type-meta)] leading-[1.4] text-pretty"><slot>{{ value }}</slot></span>
  </div>
</template>
